import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";
import axios from "axios";

const removeConditionalLogic = async ({ testCaseId, testStepIds = [] }) => {
  const user = getUserDetails();

  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=clearConditionLogic&companyid=${user.companyid}`,
    {
      testcaseid: testCaseId,
      teststepid: testStepIds,
    },
  );

  return response.data;
};

const useRemoveConditionalLogic = (options = {}) => {
  return useMutation({
    mutationFn: removeConditionalLogic,
    ...options,
  });
};

export default useRemoveConditionalLogic;
